FormsRadioDirective.$inject = [];

function FormsRadioDirective() {
  FormsRadioController.$inject = ['$scope'];

  function FormsRadioController($scope) {
    var ctrl = {
      checked: false,

      init: function () {
        $scope.$on(
          '$destroy',
          $scope.$watch('ngModel', function (n, o) {
            ctrl.checked = n == $scope.value; // Intentional type coersion
          })
        );
      },
    };

    $scope.formsRadio = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/forms/radio/radio.tpl.html',
    require: { ngModelCtrl: 'ngModel' },
    scope: {
      ngModel: '<',
      label: '=',
      value: '=',
      validTest: '=',
      id: '@',
      name: '@',
      errorMessage: '@',
    },

    link: function ($scope, $element, $attrs, controllers) {
      // Modified after controller runs
      $scope.ngModelChange = function () {
        controllers.ngModelCtrl.$setViewValue($scope.ngModel);
      };
    },

    controller: FormsRadioController,
  };
}

angular.module('acme.common.directive.forms.radio', []).directive('formsRadio', FormsRadioDirective);
